import { render, staticRenderFns } from "./FromStripePage.vue?vue&type=template&id=5104e24e&"
import script from "./FromStripePage.vue?vue&type=script&lang=js&"
export * from "./FromStripePage.vue?vue&type=script&lang=js&"
import style0 from "./FromStripePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports